import { Lock, HeartHandshake, Car, Sofa, ShieldCheck, Sparkles } from "lucide-react";
import { useI18n } from "../i18n/LanguageContext";

const TrustStrip = () => {
    const { t } = useI18n();
    const items = [
        { icon: Lock, label: t.trust.private },
        { icon: HeartHandshake, label: t.trust.personal },
        { icon: Car, label: t.trust.driver },
        { icon: Sofa, label: t.trust.comfort },
        { icon: ShieldCheck, label: t.trust.safety },
        { icon: Sparkles, label: t.trust.flexibility },
    ];
    return (
        <section
            data-testid="trust-strip"
            className="bg-brand-navy text-white relative overflow-hidden"
        >
            <div className="absolute inset-x-0 top-0 h-px bg-brand-gold/40" />
            <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 md:py-14">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-y-8 gap-x-6">
                    {items.map(({ icon: Icon, label }) => (
                        <div
                            key={label}
                            data-testid={`trust-item-${label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="flex flex-col items-center text-center gap-3 group"
                        >
                            <span className="p-3 border border-brand-gold/40 rounded-full group-hover:border-brand-gold group-hover:bg-brand-gold/10 transition-all">
                                <Icon className="w-5 h-5 text-brand-gold" />
                            </span>
                            <span className="font-sans text-xs md:text-sm tracking-wide text-white/90">
                                {label}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
            <div className="absolute inset-x-0 bottom-0 h-px bg-brand-gold/40" />
        </section>
    );
};

export default TrustStrip;
